export default {"src":"/_next/static/media/letter-s (1) 1.b68e1682.svg","height":114,"width":114,"blurWidth":0,"blurHeight":0};